import React, { useEffect, useState } from "react";
import axios from "axios";
import cookie from "js-cookie";
import { toast } from "react-toastify";
import Loader from "../../components/shared/Loader";
import { useDispatch, useSelector } from "react-redux";
import { updateMeta } from "../../store/actions/metaAction";
import { useForm } from "react-hook-form";

const HeroShow = () => {
	const dispatch = useDispatch();
	const { register, handleSubmit, reset } = useForm();

	const auth = useSelector(state => state.auth.user);

	const [loading, setLoading] = useState(true);
	const [items, setItems] = useState([]);

	useEffect(() => {
		onStart();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	const onStart = () => {
		dispatch(
			updateMeta({
				title: "تعديل مقدمة الموقع",
				breadcrumb: " مقدمة الموقع",
				button: {
					show: false,
					text: null,
					link: null,
				},
			})
		);

		axios
			.get(`${process.env.REACT_APP_API_URL}/posts/451`, {
				headers: {
					Authorization: `Bearer ${cookie.get("token")}`,
					Accept: "application/json",
				},
			})
			.then(function (response) {
				setLoading(false);

				reset({
					secTitle: response.data.data.data.secTitle,
					secDescription: response.data.data.data.secDescription,
				});
				setItems(response.data.data.data.items || []);
			})
			.catch(function (error) {
				toast.error("خطأ، برجاء المحاولة لاحقا!");
			});
	};

	const onSubmit = data => {
		setLoading(true);
		data.items = items;
		data.items = items.map(item => ({ text: item.text, value: item.value }));

		axios
			.put(
				`${process.env.REACT_APP_API_URL}/posts/451`,
				{
					category_id: 8,
					admin_id: auth.data.id,
					data: data,
				},
				{
					headers: {
						Authorization: `Bearer ${cookie.get("token")}`,
						Accept: "application/json",
					},
				}
			)
			.then(function (response) {
				toast.success("تم تحديث السؤال بنجاح!");
				setLoading(false);
			})
			.catch(function (error) {
				toast.error("خطأ، برجاء المحاولة مره اخرى!");
				setLoading(false);
			});
	};

	return (
		<section>
			{loading && <Loader />}
			<form onSubmit={handleSubmit(onSubmit)}>
				<div className="card ">
					<div className="card-body">
						<div className="form-item">
							<label>عنوان </label>
							<input type="text" {...register("secTitle")} />
						</div>
						<div className="form-item">
							<label>وصف </label>
							<textarea {...register("secDescription")} rows={5} />
						</div>
						<div className="card">
							<div className="d-flex align-items-center gap-3 justify-content-between card-header">
								العناصر
								<button
									type="button"
									className="btn btn-success"
									onClick={() => {
										setItems([...items, { text: "", value: "" }]);
									}}
								>
									+ اضافة
								</button>
							</div>
							{/* add dynamic items with text and value */}
							{items?.length > 0 ? (
								<div className="card-body">
									{items?.map((item, index) => (
										<div key={index} className="card mt-4 bg-body-tertiary">
											<div className="card-body">
												<div className="form-item">
													<label>عنوان </label>
													<input
														type="text"
														value={item.text}
														onChange={e => {
															const newItems = [...items];
															newItems[index].text = e.target.value;
															setItems(newItems);
														}}
													/>
												</div>
												<div className="form-item">
													<label>قيمة </label>
													<input
														type="text"
														value={item.value}
														onChange={e => {
															const newItems = [...items];
															newItems[index].value = e.target.value;
															setItems(newItems);
														}}
													/>
												</div>
												<div className="form-item mb-0">
													<button
														type="button"
														className="btn btn-danger w-100"
														onClick={() => {
															setItems([
																...items.slice(0, index),
																...items.slice(index + 1),
															]);
														}}
													>
														- حذف
													</button>
												</div>
											</div>
										</div>
									))}
								</div>
							) : (
								<div className="card-body">
									<p className="mb-0 text-center">لا يوجد عناصر</p>
								</div>
							)}
						</div>
						<div className="form-item mt-4">
							<button className="bt bt-success btn-block" type="submit">
								ارسال
							</button>
						</div>
					</div>
				</div>
			</form>
		</section>
	);
};

export default HeroShow;
